import styled from "styled-components";
import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import AutoresponderSubscribers from "../autoresponder/AutoresponderSubscribers";

const AutoresponderSubscribersContainer = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MLARGE};
`;

export default ({ autoresponderId }) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);

  const limit = 10;

  // Fetch data
  const GET_RESPONDER_SUBSCRIBERS_DATA = gql`
    query GetResponderSubscribersData(
      $responderId: ID!
      $page: Int!
      $limit: Int!
    ) {
      responderSubscribersData(
        responderId: $responderId
        page: $page
        limit: $limit
      ) {
        subscribers {
          id
          created_at
          name
          email
          location_country
          sent_emails_aggregate {
            aggregate {
              count
            }
          }
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_RESPONDER_SUBSCRIBERS_DATA, {
    variables: {
      responderId: autoresponderId,
      page,
      limit,
    },
    skip: !autoresponderId,
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching responder subscribers data", error);
    captureException(error);
  }

  const openLead = (id) => {
    navigate(
      `/lead-detail?id=${id}&from=autoresponder&autoresponderId=${autoresponderId}`
    );
  };

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  console.log("data", data);

  return (
    <AutoresponderSubscribersContainer>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="300px" />
        </LoadingBox>
      )}
      {data && (
        <AutoresponderSubscribers
          data={data}
          page={page}
          limit={limit}
          paginate={paginate}
          openLead={openLead}
        />
      )}
    </AutoresponderSubscribersContainer>
  );
};
